import React from 'react';
import { Box, Icon } from '@chakra-ui/react';
import { FaVideo, FaCamera } from 'react-icons/fa';
import { ff } from '../../../theme';

const LOOK = {
  video: { bg: ff.ink, fg: ff.lime, icon: FaVideo },
  photo: { bg: ff.grey, fg: ff.ink, icon: FaCamera },
};

/** The UGC piece mark: ink video tile (lime icon) or grey photo tile (ink icon), with an ink "UGC" badge. */
const UgcPieceIcon: React.FC<{ type: 'video' | 'photo'; size?: number }> = ({ type, size = 36 }) => {
  const look = LOOK[type];
  return (
    <Box position="relative" w={`${size}px`} h={`${size}px`} flexShrink={0}>
      <Box
        w="100%"
        h="100%"
        borderRadius={`${Math.round(size * 0.28)}px`}
        bg={look.bg}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Icon as={look.icon} color={look.fg} boxSize={`${Math.round(size * 0.44)}px`} />
      </Box>
      <Box
        position="absolute"
        right={`${-Math.round(size * 0.12)}px`}
        bottom={`${-Math.round(size * 0.1)}px`}
        bg={ff.ink}
        color={ff.lime}
        border="1.5px solid white"
        borderRadius="4px"
        px="3px"
        fontSize={`${Math.max(6, Math.round(size * 0.2))}px`}
        fontWeight={600}
        lineHeight="1.35"
        letterSpacing="0.02em"
      >
        UGC
      </Box>
    </Box>
  );
};

export default UgcPieceIcon;
